
export default {
  name: 'RecaptchaInput',
  props: {
    value: String,
    error: String
  },
  head: {
    script: [
      {
        src: 'https://www.google.com/recaptcha/api.js?onload=onloadCaptcha&render=explicit&hl=ar',
        async: true
      }
    ]
  },
  created () {
    this.newValue = this.value
  },
  mounted () {
    var onloadCaptcha = this.onloadCaptcha
    window.onloadCaptcha = onloadCaptcha
    if (typeof grecaptcha !== 'undefined') {
      this.renderRecaptcha()
    }
  },
  data () {
    return {
      newValue: String
    }
  },
  watch: {
    newValue () {
      this.$emit('input', this.newValue)
    },
    value () {
      if (this.value.length === 0 && typeof grecaptcha !== 'undefined') {
        grecaptcha.reset()
      }
    }
  },
  methods: {
    setCaptchaToken (token) {
      this.newValue = token
    },
    onloadCaptcha () {
      this.renderRecaptcha()
    },
    renderRecaptcha () {
      try {
        grecaptcha.render('g-recaptcha', {
          'sitekey': process.env.GOOGLE_RECAPTCHA_SITE_KEY,
          'callback': this.setCaptchaToken
        })
      } catch (e) {
      }
    },
  }
}
